import { flump } from "../../PhaserExtension";

export default class FlumpObject extends Phaser.Sprite
{
    constructor(game, config, library)
    {
        super(game);

        this.config = config;
        this.keys = this.config.display;
        this.library = library;

        this.display = flump.libraries[library].createClip(this.keys.idle);
        this.addChild(this.display);

        if(this.config.transform && this.config.transform.position)
        {
            this.position.setTo(this.config.transform.position.x, this.config.transform.position.y);
        }

        // Convenience.
        this.loop = this.display.loop.bind(this.display);
        this.playOnce = this.display.playOnce.bind(this.display);
        this.onComplete = this.display.onComplete;

        this.loop(this.keys.idle, true);
    }

    reassign(config, library, keepPosition = false)
    {
        delete this.config;
        delete this.keys;
        this.config = config;
        this.keys = this.config.display;

        if(library && library !== this.library)
        {
            this.display.destroy(true);
            delete this.display;
            this.display = flump.libraries[library].createClip(this.keys.idle);
            this.loop(this.keys.idle, true);
        }

        if(!keepPosition && this.config.transform && this.config.transform.position)
        {
            this.position.setTo(this.config.transform.position.x, this.config.transform.position.y);
        }
    }

    update()
    {
        if(this.display != null)
        {
            this.display.update();
        }
    }

    destroy(children)
    {
        this.display.destroy();
        delete this.display;
        delete this.keys;
        delete this.library;
        delete this.config;
        delete this.loop;
        delete this.playOnce;
        delete this.onComplete;
        super.destroy(children);
    }
}
